import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules"; // Removed Navigation
import "swiper/css";
import "swiper/css/autoplay"; // Removed navigation CSS import

const BannerSlider = () => {
  const swiperRef = useRef(null);

  return (
    <div style={{ position: "relative" }}>
      <Swiper
        ref={swiperRef}
        modules={[Autoplay]} // Removed Navigation
        spaceBetween={30}
        loop={true}
        autoplay={{ delay: 3000 }}
        slidesPerView={1}
      >
        {[1, 2].map((num, index) => (
          <SwiperSlide key={index}>
            <a href="#">
              <img
                className="img-fluid"
                src={`/assets/images/recharge-earn-banner.png`}
                alt={`banner ${num}`}
                style={{ width: "100%", height: "auto" }}
              />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div
        className="swiper-button-prev"
        style={{
          position: "absolute",
          top: "50%",
          left: "10px",
          zIndex: "10",
          transform: "translateY(-50%)",
          width: "30px",
          height: "30px",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => swiperRef.current.swiper.slidePrev()}
      >
        <i className="fa fa-chevron-left" style={{ color: "white" }}></i>
      </div>
      <div
        className="swiper-button-next"
        style={{
          position: "absolute",
          top: "50%",
          right: "10px",
          zIndex: "10",
          transform: "translateY(-50%)",
          width: "30px",
          height: "30px",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => swiperRef.current.swiper.slideNext()}
      >
        <i className="fa fa-chevron-right" style={{ color: "white" }}></i>
      </div>
    </div>
  );
};

export default BannerSlider;
